var _defs, _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBlur01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 957 767",
    width: 957,
    height: 767,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg_blur-01-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    id: "f1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 61.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(128.102,259.21,-317.212,156.767,432.543,301.782)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#860d1c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860d1c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    id: "f2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-81.359,-198.016,275.734,-113.291,582.466,447.715)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#860d1c",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860d1c",
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: .8;filter: url(#f1);fill: url(#g1) } \n\t\t.s1 { filter: url(#f2);fill: url(#g2) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m477.5 537c-119.7 0-216.5-68.8-216.5-154 0-85.2 96.8-154 216.5-154 119.7 0 216.5 68.8 216.5 154 0 85.2-96.8 154-216.5 154z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m521.4 485.7c-81.4 0-147.3-40.6-147.3-90.8 0-50.3 65.9-90.9 147.3-90.9 81.5 0 147.4 40.6 147.4 90.9 0 50.2-65.9 90.8-147.4 90.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlur01);
export default __webpack_public_path__ + "static/media/bg_blur-01.27b4c9cdf847e87a80c2c1c0f8144a0d.svg";
export { ForwardRef as ReactComponent };